import { render, staticRenderFns } from "./ManageDocumentTypesModal.vue?vue&type=template&id=a0114da4&scoped=true"
import script from "./ManageDocumentTypesModal.vue?vue&type=script&lang=js"
export * from "./ManageDocumentTypesModal.vue?vue&type=script&lang=js"
import style0 from "./ManageDocumentTypesModal.vue?vue&type=style&index=0&id=a0114da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0114da4",
  null
  
)

export default component.exports